import { path } from 'ramda'

const BOARD_PATH = ['board']
const ACTIVITY_PATH = [...BOARD_PATH, '@board/activity']
const TRENDING_POST_PATH = [...BOARD_PATH, '@board/trending-post']

export const activitySelector = path(ACTIVITY_PATH)

export const trendingPostSelector = path(TRENDING_POST_PATH)
